(function($){

    const CCIMain = {

        init: () => {
            CCIMain.initMenus();
        },
        initMenus: () => {
            $('.top-menu li.menu-item-has-children .sub-menu').before('<button class="sub-menu-toggle"></button>');
        },
        headerOnScroll: () => {

            const scroll = $(window).scrollTop();

            if( scroll >= 1 ) {
                $('#header').addClass('scroll');
            }

            if( scroll < 1 ) {
                $('#header').removeClass('scroll');
            }

        },
        toggleFooter: () => {
            if ($(window).scrollTop() + $(window).height() >= $(document).height() - 10) {
                $('footer .corner').addClass('visible');
            } else {
                $('footer .corner').removeClass('visible');
            }
        },
        toggleMobileMenu: ( trigger ) => {
            let menu = trigger.attr('data-menu');
            if( menu ) {
                trigger.toggleClass('active');
                $( menu ).toggleClass('active');
            }
        },
        toggleSubMenu: menuItem => {
            menuItem.toggleClass('active');
            menuItem.next('.sub-menu').toggleClass('active');
            menuItem.parent().toggleClass('active');
        },
        filterProjectsByCategory: category => {

            const slug = category.attr('class').split(' ')[0];

            if( 'all' == slug ) {
                $('.projects-list li').show();
                return;
            }

            $('.projects-categories li').removeClass('active');
            category.addClass('active');

            $('.projects-list li').each(function(){
                const project = $(this);
                const projectCategories = project.attr('class').split(' ');
                if( projectCategories.indexOf(slug) > -1 ) {
                    project.show();
                } else {
                    project.hide();
                }
            });

        },
        followSingleProject: project => {
            
            const url = project.find('.project-link a').attr('href');

            if( url ) {
                window.location.href = url;
            }
            
        },
        filterServicesByCategory: category => {

            const slug = category.attr('class').split(' ')[0];

            if( 'all' === slug ) {
                $('.services li').show();
                return;
            }

            $('.services-categories li').removeClass('active');
            category.addClass('active');

            $('.services-list li').each(function(){
                const service = $(this);
                const serviceCategories = service.attr('class').split(' ');
                if( serviceCategories.indexOf(slug) > -1 ) {
                    service.show();
                } else {
                    service.hide();
                }
            });

        },
        followSingleService: service => {
            
            const url = service.find('.service-link a').attr('href');

            if( url ) {
                window.location.href = url;
            }
            
        },
        toggleJobDesc: job => {
            job.parent().find('.job-details').slideToggle();
        }

    }

    $(function(){

        CCIMain.init();

        $(window).on('scroll', function(evt) {
            CCIMain.headerOnScroll();
            CCIMain.toggleFooter();
        });

        $('#mobile-nav-toggle').on('click', function(evt){
            evt.preventDefault();
            CCIMain.toggleMobileMenu( $(this) );
        });

        $('body').on('click', '.sub-menu-toggle', function(evt){
            CCIMain.toggleSubMenu( $(this) );
        });

        $('body').on('click', '.projects-categories li', function(evt){
            CCIMain.filterProjectsByCategory( $(this) );
        });

        $('body').on('click', '.projects-list li', function(evt){
            CCIMain.followSingleProject( $(this) );
        });
        
        $('body').on('click', '.services-categories li', function(evt){
            CCIMain.filterServicesByCategory( $(this) );
        });

        $('body').on('click', '.services-list li', function(evt){
            CCIMain.followSingleService( $(this) );
        });

        $('body').on('click', '.job-list li a', function(evt){
            CCIMain.toggleJobDesc( $(this) );
        });

    });

})(jQuery);